import { type Transition, useReducedMotion } from 'motion/react';
import { useEffect, useState } from 'react';

/**
 * Motion of the schema form: a unit growing into its editor, a row entering
 * or leaving a list. Heights ease instead of jumping, so the content below
 * moves with them. Same curve as Tailwind's `duration-200 ease-out`, which the
 * unit card's own margins, padding and colours transition with — the card's
 * edges and its content move together.
 */
const UNIT_TRANSITION: Transition = { duration: 0.2, ease: [0, 0, 0.2, 1] };
const INSTANT: Transition = { duration: 0 };

/** The engine's transition, or none when the OS asks for reduced motion. */
export function useUnitTransition(): Transition {
  return useReducedMotion() ? INSTANT : UNIT_TRANSITION;
}

/**
 * `appear` for a list's rows: `false` while the list first renders — its
 * rows are just there — and `true` for rows added afterwards.
 */
export function useNewRowsAppear(): boolean {
  const [appear, setAppear] = useState(false);
  useEffect(() => setAppear(true), []);
  return appear;
}
